import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import { createGlobalStyle, ThemeProvider as SCThemeProvider, th } from '@xstyled/styled-components';
import { theme } from '../theme';
export var GlobalStyle = createGlobalStyle(_templateObject(), th('global'));
export function ThemeProvider(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(SCThemeProvider, {
    theme: theme
  }, children);
}